class Product360VideoViewer {
  constructor(container) {
    this.container = container;
    this.videoElement = null;
    this.isDragging = false;
    this.startX = 0;
    this.currentTime = 0;
    this.sensitivity = 0.0005; // Lower value = smoother drag
    this.isAutoPlaying = true;
    this.loopInterval = null;

    console.log("Initializing 360 Video Viewer...");
    this.initViewer();
  }

  initViewer() {
    this.videoElement = this.container.querySelector("#product-360-video");

    if (!this.videoElement) {
      console.warn("360 Video element not found!");
      return;
    }

    this.container.style.display = "block";
    this.container.style.visibility = "visible";
    this.container.style.opacity = "1";

    this.videoElement.loop = false; // Disable default looping (we handle it manually)
    this.videoElement.muted = true;
    this.videoElement.play();

    // Start smooth auto-looping
    this.startAutoLoop();

    this.container.addEventListener("mousedown", (e) => this.startDrag(e));
    document.addEventListener("mouseup", () => this.stopDrag());
    document.addEventListener("mousemove", (e) => this.drag(e));
  }

  startDrag(event) {
    this.isDragging = true;
    this.startX = event.pageX;
    this.videoElement.pause();
    this.isAutoPlaying = false;
    clearInterval(this.loopInterval);
  }

  drag(event) {
    if (!this.isDragging) return;

    let deltaX = event.pageX - this.startX;
    this.startX = event.pageX;

    // Smoothly adjust playback position
    let newTime = this.videoElement.currentTime + deltaX * this.sensitivity * this.videoElement.duration;

    // Implement seamless looping
    if (newTime >= this.videoElement.duration) {
      newTime = 0;
    } else if (newTime < 0) {
      newTime = this.videoElement.duration;
    }

    this.videoElement.currentTime = newTime;
  }

  stopDrag() {
    this.isDragging = false;
    this.startAutoLoop(); // Resume auto-loop after dragging stops
  }

  startAutoLoop() {
    if (!this.isAutoPlaying) return;
    
    this.loopInterval = setInterval(() => {
      if (this.videoElement.currentTime >= this.videoElement.duration - 0.1) {
        this.videoElement.currentTime = 0; // Smooth restart
      }
    }, 30); // Runs every 30ms for a smooth effect
  }
}

// Initialize the viewer when the page loads
function initialize360Viewer() {
  const viewerContainer = document.getElementById("product-360-video-wrapper");
  if (viewerContainer) {
    new Product360VideoViewer(viewerContainer);
  } else {
    console.warn("360 Viewer container not found.");
  }
}

document.addEventListener("DOMContentLoaded", initialize360Viewer);
document.addEventListener("shopify:section:load", initialize360Viewer);
